(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    document.documentElement.classList.add('js');

    const drawer = document.querySelector('[data-cart-drawer]');
    const drawerBody = document.querySelector('[data-cart-drawer-body]');
    const stringsNode = document.querySelector('[data-cart-strings]');
    const liveRegion = document.querySelector('[data-cart-live-region]');

    if (!drawer || !drawerBody || !stringsNode) return;

    const strings = JSON.parse(stringsNode.textContent);
    // Market locales may return root_url without a trailing slash (e.g. "/da-dk").
    // Cart Ajax paths must be joined with a slash or requests hit /da-dkcart/add.js.
    if (strings.rootUrl && !strings.rootUrl.endsWith('/')) {
      strings.rootUrl = `${strings.rootUrl}/`;
    }
    let lastTrigger = null;
    let pendingRequest = null;

    const getCartTriggers = () => document.querySelectorAll('[data-cart-open]');

    const updateTriggers = (count, open) => {
      getCartTriggers().forEach((trigger) => {
        if (typeof open === 'boolean') {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        if (typeof count !== 'number') return;

        let badge = trigger.querySelector('[data-cart-count]');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            badge.setAttribute('data-cart-count', '');
            badge.setAttribute('aria-hidden', 'true');
            trigger.appendChild(badge);

            const sr = document.createElement('span');
            sr.className = 'visually-hidden';
            sr.setAttribute('data-cart-count-label', '');
            trigger.appendChild(sr);
          }
          badge.textContent = String(count);
          const label = trigger.querySelector('[data-cart-count-label]');
          if (label && strings.cartCountTemplate) {
            label.textContent = strings.cartCountTemplate.replace('__COUNT__', String(count));
          }
        } else {
          badge?.remove();
          trigger.querySelector('[data-cart-count-label]')?.remove();
        }
      });
    };

    const announce = (message) => {
      if (!liveRegion || !message) return;
      liveRegion.textContent = '';
      window.setTimeout(() => {
        liveRegion.textContent = message;
      }, 20);
    };

    const setLoading = (loading) => {
      drawerBody.classList.toggle('is-loading', loading);
      document.querySelector('[data-cart-page]')?.classList.toggle('is-loading', loading);
      const scope = document.querySelector('[data-cart-drawer-content], [data-cart-page]');
      scope?.querySelectorAll('[data-cart-quantity-decrease], [data-cart-quantity-increase], [data-cart-remove]').forEach((control) => {
        control.disabled = loading;
      });
    };

    const bindDrawerEvents = () => {
      drawerBody.querySelectorAll('[data-cart-quantity-decrease]').forEach((button) => {
        button.addEventListener('click', () => {
          const lineKey = button.dataset.lineKey;
          const input = drawerBody.querySelector(`[data-cart-quantity-input][data-line-key="${lineKey}"]`);
          const current = Number.parseInt(input?.value || '1', 10);
          changeLine(lineKey, Math.max(1, current - 1));
        });
      });

      drawerBody.querySelectorAll('[data-cart-quantity-increase]').forEach((button) => {
        button.addEventListener('click', () => {
          const lineKey = button.dataset.lineKey;
          const input = drawerBody.querySelector(`[data-cart-quantity-input][data-line-key="${lineKey}"]`);
          const current = Number.parseInt(input?.value || '1', 10);
          changeLine(lineKey, current + 1);
        });
      });

      drawerBody.querySelectorAll('[data-cart-remove]').forEach((button) => {
        button.addEventListener('click', () => changeLine(button.dataset.lineKey, 0));
      });
    };

    const renderCartPage = async () => {
      const cartPage = document.querySelector('[data-cart-page]');
      if (!cartPage) return;

      const sectionId = cartPage.dataset.cartSectionId;
      if (!sectionId) return;

      const response = await fetch(`${strings.cartUrl}?sections=${sectionId}`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(strings.error);

      const payload = await response.json();
      const html = payload[sectionId];
      if (!html) throw new Error(strings.error);

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const nextSection = template.content.querySelector('[data-cart-page]');
      if (nextSection) {
        cartPage.innerHTML = nextSection.innerHTML;
      }
    };

    const refreshCartPage = async () => {
      if (!document.querySelector('[data-cart-page]')) return;
      await renderCartPage();
    };

    const renderSection = async () => {
      const response = await fetch(`${strings.rootUrl}?sections=${strings.sectionId}`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(strings.error);

      const payload = await response.json();
      const html = payload[strings.sectionId];
      if (!html) throw new Error(strings.error);

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const content = template.content.querySelector('[data-cart-drawer-content]');
      drawerBody.innerHTML = content ? content.outerHTML : html;
      bindDrawerEvents();
    };

    const refresh = async () => {
      if (pendingRequest) return pendingRequest;

      pendingRequest = (async () => {
        setLoading(true);
        try {
          const cartResponse = await fetch(`${strings.rootUrl}cart.js`);
          const cart = await cartResponse.json();
          await renderSection();
          updateTriggers(cart.item_count, drawer.open);
          return cart;
        } finally {
          setLoading(false);
          pendingRequest = null;
        }
      })();

      return pendingRequest;
    };

    const changeLine = async (lineKey, quantity) => {
      if (!lineKey || pendingRequest) return;

      setLoading(true);
      try {
        const response = await fetch(`${strings.rootUrl}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: lineKey, quantity }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || strings.error);
        }

        const cart = await response.json();
        if (drawer.open) {
          await renderSection();
        }
        await refreshCartPage();
        updateTriggers(cart.item_count, drawer.open);
      } catch (error) {
        announce(error.message || strings.error);
      } finally {
        setLoading(false);
      }
    };

    const open = (trigger) => {
      lastTrigger = trigger || lastTrigger;
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      }
      updateTriggers(undefined, true);
      const closeButton = drawer.querySelector('[data-cart-drawer-close]');
      closeButton?.focus();
    };

    const close = () => {
      if (!drawer.open) return;
      drawer.close();
      updateTriggers(undefined, false);
      if (lastTrigger) lastTrigger.focus();
    };

    const addItems = async (items) => {
      const response = await fetch(`${strings.rootUrl}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.description || strings.error);
      }

      await refresh();
      announce(strings.added);
      return payload;
    };

    window.themeCart = {
      open,
      close,
      refresh,
      addItems,
      changeLine,
      announce,
    };

    bindDrawerEvents();

    getCartTriggers().forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (trigger.tagName === 'A') {
          event.preventDefault();
        }
        lastTrigger = trigger;
        open(trigger);
        refresh();
      });
    });

    drawer.querySelector('[data-cart-drawer-close]')?.addEventListener('click', close);

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) close();
    });

    document.addEventListener('click', (event) => {
      const pageControl = event.target.closest('[data-cart-quantity-decrease], [data-cart-quantity-increase], [data-cart-remove]');
      if (!pageControl || pageControl.closest('[data-cart-drawer]')) return;

      event.preventDefault();
      const lineKey = pageControl.dataset.lineKey;
      if (pageControl.matches('[data-cart-remove]')) {
        window.themeCart.changeLine(lineKey, 0);
        return;
      }

      const input = document.querySelector(`[data-cart-quantity-input][data-line-key="${lineKey}"]`);
      const current = Number.parseInt(input?.value || '1', 10);
      const next = pageControl.matches('[data-cart-quantity-decrease]') ? Math.max(1, current - 1) : current + 1;
      window.themeCart.changeLine(lineKey, next);
    });

    fetch(`${strings.rootUrl}cart.js`)
      .then((response) => response.json())
      .then((cart) => updateTriggers(cart.item_count, false))
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-inline-search"] && !Shopify.designMode) return;
  try {
    (function () {
    const form = document.querySelector('[data-header-search-form]');
    const input = document.querySelector('[data-header-search-input]');
    const dialog = document.querySelector('[data-search-dialog]');
    const dialogInput = document.querySelector('[data-predictive-search-input]');

    if (!form || !input) return;

    input.addEventListener('focus', () => {
      if (!dialog || !dialogInput) return;
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
      dialogInput.value = input.value;
      window.setTimeout(() => dialogInput.focus(), 0);
    });

    form.addEventListener('submit', (event) => {
      if (input.value.trim().length === 0) {
        event.preventDefault();
      }
    });

    dialogInput?.addEventListener('input', () => {
      input.value = dialogInput.value;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    const stringsNode = document.querySelector('[data-predictive-search-strings]');
    if (!stringsNode) return;

    const strings = JSON.parse(stringsNode.textContent);
    const dialog = document.querySelector('[data-search-dialog]');
    const input = document.querySelector('[data-predictive-search-input]');
    const results = document.querySelector('[data-predictive-search-results]');
    const openButtons = document.querySelectorAll('[data-search-open]');
    const closeButtons = document.querySelectorAll('[data-search-close]');

    if (!dialog || !input || !results) return;

    let debounceTimer;
    let activeController;

    const openSearch = () => {
      if (mobileNav?.open) {
        mobileNav.close();
        document.documentElement.classList.remove('mobile-nav-open');
      }
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      input.value = '';
      renderInitial();
      window.setTimeout(() => input.focus(), 0);
    };

    const closeSearch = () => {
      if (dialog.open) dialog.close();
      if (activeController) activeController.abort();
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', openSearch);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeSearch);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeSearch();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeSearch();
    });

    const renderInitial = () => {
      input.setAttribute('aria-expanded', 'false');
      results.innerHTML = `<p class="predictive-search__empty">${strings.initialGuidance}</p>`;
    };

    const formatMoney = (value) => {
      const amount = Number.parseFloat(value);
      if (Number.isNaN(amount)) return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'DKK',
      }).format(amount);
    };

    const renderResults = (payload, query) => {
      const resources = payload?.resources?.results || {};
      const products = resources.products || [];
      const collections = resources.collections || [];
      const pages = resources.pages || [];
      const articles = resources.articles || [];
      const totalCount = products.length + collections.length + pages.length + articles.length;

      if (totalCount === 0) {
        input.setAttribute('aria-expanded', 'false');
        results.innerHTML = `<p class="predictive-search__status">${strings.noResults}</p>`;
        return;
      }

      input.setAttribute('aria-expanded', 'true');
      let html = '';

      if (products.length > 0) {
        html += `<div class="predictive-search__group"><p class="predictive-search__group-title">${strings.productsHeading}</p><ul class="predictive-search__list">`;
        products.forEach((product) => {
          const image = product.image
            ? `<img src="${product.image}" alt="" width="48" height="48" loading="lazy">`
            : '';
          const price = product.price ? `<p class="predictive-search__item-price">${formatMoney(product.price)}</p>` : '';
          html += `<li role="option"><a class="predictive-search__item-link" href="${product.url}"><div class="predictive-search__item-media">${image}</div><div><p class="predictive-search__item-title">${product.title}</p>${price}</div></a></li>`;
        });
        html += '</ul></div>';
      }

      if (collections.length > 0) {
        html += `<div class="predictive-search__group"><p class="predictive-search__group-title">${strings.collectionsHeading}</p><ul class="predictive-search__list">`;
        collections.forEach((collection) => {
          html += `<li role="option"><a class="predictive-search__item-link predictive-search__item-link--text" href="${collection.url}"><p class="predictive-search__item-title">${collection.title}</p></a></li>`;
        });
        html += '</ul></div>';
      }

      if (pages.length > 0) {
        html += `<div class="predictive-search__group"><p class="predictive-search__group-title">${strings.pagesHeading}</p><ul class="predictive-search__list">`;
        pages.forEach((page) => {
          html += `<li role="option"><a class="predictive-search__item-link predictive-search__item-link--text" href="${page.url}"><p class="predictive-search__item-title">${page.title}</p></a></li>`;
        });
        html += '</ul></div>';
      }

      if (articles.length > 0) {
        html += `<div class="predictive-search__group"><p class="predictive-search__group-title">${strings.articlesHeading}</p><ul class="predictive-search__list">`;
        articles.forEach((article) => {
          html += `<li role="option"><a class="predictive-search__item-link predictive-search__item-link--text" href="${article.url}"><p class="predictive-search__item-title">${article.title}</p></a></li>`;
        });
        html += '</ul></div>';
      }

      html += `<div class="predictive-search__footer"><a class="predictive-search__view-all" href="${strings.searchUrl}?q=${encodeURIComponent(query)}">${strings.viewAll}</a></div>`;
      results.innerHTML = html;
    };

    const fetchResults = (query) => {
      if (activeController) activeController.abort();
      activeController = new AbortController();

      const endpoint = `${strings.rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=4&resources[options[unavailable_products]]=last`;

      fetch(endpoint, { signal: activeController.signal })
        .then((response) => response.json())
        .then((payload) => renderResults(payload, query))
        .catch((error) => {
          if (error.name === 'AbortError') return;
          results.innerHTML = `<p class="predictive-search__status">${strings.noResults}</p>`;
        });
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(debounceTimer);

      if (query.length === 0) {
        renderInitial();
        return;
      }

      if (query.length < 2) return;

      debounceTimer = window.setTimeout(() => fetchResults(query), 250);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
